import { makeStyles, createStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: variables.white,
    },

    rotateIcon: {
      animation: '$spin 2s linear infinite',
    },
    '@keyframes spin': {
      '0%': {
        transform: 'rotate(-360deg)',
      },
      '100%': {
        transform: 'rotate(0deg)',
      },
    },
  }),
);
